import axios from 'axios';

export const buscarMensgemCidadaoAtual = () => {
  return axios.get(`/admin/mensagem-cidadao/atual`);
};
